import getViewItemState from './view-item/initial-state';

export default initData => {
    if (initData && initData.module) {
        const mod = initData.module.split('/');
        // can dynamically import the getInitialState from file in folder of mod[4] and execute
        switch (mod[4]) {
            case 'view-item':
                return { viewItem: getViewItemState(initData) };
            default:
                return {};
        }
    }

    return {};
};
